export enum PaymentAccountType {
  Unknown = 'Unknown',
  Banking = 'Banking',
  Card = 'Card',
  Visa = 'Visa',
  MasterCard = 'MasterCard',
  AmericanExpress = 'AmericanExpress',
  Discover = 'Discover',
  ApplePay = 'Apple Pay',
  GooglePay = 'Google Pay',
  PayPal = 'PayPal',
  Venmo = 'Venmo',
  Cash = 'Cash',
}
